import Icon from '../ui/Icon'
import Button from '../ui/Button'

/**
 * NumberDisplay Component
 * Displays phone number information and call button
 * Separated for better maintainability and reusability
 */
const NumberDisplay = ({ number, onMakeCall }) => {
  if (!number) return null

  return (
    <div className="bg-gray-50 rounded-lg p-4">
      <div className="text-center">
        <div className="text-2xl font-bold text-gray-800 mb-1">
          {number.phone_number}
        </div>
        <div className="text-gray-600">
          {number.first_name} {number.last_name}
        </div>
        {number.country && (
          <div className="text-sm text-gray-500">{number.country}</div>
        )}

        {/* Display Personal Call Time Preference */}
        {number.personal_call_time && (
          <div className="mt-2 bg-blue-50 border border-blue-200 rounded-md px-3 py-2">
            <div className="flex items-center justify-center text-blue-700">
              <Icon name="Clock" className="w-4 h-4 mr-2" />
              <span className="text-sm font-medium">
                {number.personal_call_time.message}
              </span>
            </div>
          </div>
        )}
      </div>

      <div className="mt-4 text-center">
        <Button
          onClick={() => onMakeCall(number.phone_number)}
          className="bg-green-600 hover:bg-green-700 text-white px-6 py-2"
        >
          <Icon name="phone" className="mr-2" />
          কল করুন
        </Button>
      </div>
    </div>
  )
}

export default NumberDisplay